import { FC } from 'react';
import { IProvider } from 'src/redux/services/provider';
import { addMethodsType } from '../Settings';
import { EditEsiaProvider } from './edit/EditEsiaProvider';
import { EditQRCodeProvider } from './edit/EditQRCodeProvider';

type TEditMethodsProps = {
  provider: IProvider | null;
  onClose: () => void;
};

export const EditMethods: FC<TEditMethodsProps> = ({ provider, onClose }) => {
  const esiaProviderAvatar = 'public/default/esia.svg';
  const qrcodeProviderAvatar = 'public/default/qrcode.svg';
  
  return (
    <>
      <EditEsiaProvider
        defaultAvatar={esiaProviderAvatar}
        provider={provider}
        isOpen={provider?.type === addMethodsType.ESIA}
        onClose={onClose}
      />
      <EditQRCodeProvider
        defaultAvatar={qrcodeProviderAvatar}
        provider={provider}
        isOpen={provider?.type === addMethodsType.QR_CODE}
        onClose={onClose}
      />
    </>
  );
};
